import { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TagGroupInputBar from "./TagGroupInputBar";
import CollectionList from "../../widgets/CollectionList";
import {
    getAllTagsAction,
    storeAllTagGroupsAction,
    storeAllTagsAction,
    getAllTagGroupsAction
}
    from '../../api/actions/actions';
import TagGroupList from "./TagGroupList";
import { Dialog } from "../modal/Dialog";
import { PlaceholderContext } from "../../contexts/Contexts";
import { ReloadSvg, NewListSvg } from "../../icons/Icon";
import CodeErrorTemplate from "../../templates/CodeErrorTemplate";
import { useEventContext } from "../../contexts/EventContextProvider";
import { createTagGroupCrudFromEvent } from "../../events/TagGroupEvents";

const CustomActions = (p) => {

    const { state, eventDispatch } = useEventContext();
    const dispatch = useDispatch();

    const onReload = () => {
        setTimeout(() => dispatch(getAllTagGroupsAction())
            .unwrap()
            .then((result) => {
                dispatch(storeAllTagGroupsAction(result.content));
            })
            .catch((error) => {
                console.log("Custom Error:", error, error.error);
            }), 0);
        
    };
    const onNew = () => {
        eventDispatch(createTagGroupCrudFromEvent());
    };

    return (
        <div className="CollectionList_actions">
            <button className="CollectionList_reload" onClick={onReload}><ReloadSvg /></button>
            <button className="CollectionList_new" onClick={onNew}><NewListSvg /></button>
        </div >
    );
}

const TagGroups = (p) => {

    const placeholder = useContext(PlaceholderContext);
    const dispatch = useDispatch();
    const tags = useSelector((state) => state.base.tags);
    const tagGroups = useSelector((state) => state.base.tagGroups);

    const showError = (error) => {
        placeholder.openModal(<Dialog><CodeErrorTemplate message={error.errors || error.error || error} /></Dialog>, {
            onApprove: (a) => {
                a.actions.close();
            }
        }, {
            heading: `Error: ${(error.status) || ''}`,
            message: ''
        })
    };

    useEffect(() => {
        if (!(Array.isArray(tags) && tags.length > 0)) {
            dispatch(getAllTagsAction()).unwrap()
                .then((result) => {
                    dispatch(storeAllTagsAction(result.content));
                })
                .catch((error) => {
                    console.log("Custom Error:", error, error.error);
                });
        }
        if (!(Array.isArray(tagGroups) && tagGroups.length > 0)) {
            dispatch(getAllTagGroupsAction())
                .unwrap()
                .then((result) => {
                    dispatch(storeAllTagGroupsAction(result.content));
                })
                .catch(showError);
        }
    }, []);

    return (
        <>
            <div className="page">
                <div className="flex-24">
                    <div className="col-24 flex-column">
                        <div className="page-box">
                            <div className='page-box-header'>
                                <h4><span>Tag group Management</span></h4>
                            </div>
                            <div className='page-box-body'>
                                <TagGroupInputBar />
                                <CollectionList
                                    itemsPerPage={10}
                                    items={tagGroups}
                                    ItemsComponent={TagGroupList}

                                    CustomActionsComponent={CustomActions}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TagGroups;